import { render, staticRenderFns } from "./uploadedFiles.vue?vue&type=template&id=5800a540&scoped=true"
import script from "./uploadedFiles.vue?vue&type=script&lang=js"
export * from "./uploadedFiles.vue?vue&type=script&lang=js"
import style0 from "./uploadedFiles.vue?vue&type=style&index=0&id=5800a540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5800a540",
  null
  
)

export default component.exports